import { get } from '@core/api/baseApi';
import { GetAssignedTechnicianResponse } from '@core/types';

const getStudyAssignedTechnician = async (studyInstanceUid: string): Promise<GetAssignedTechnicianResponse> => 
    await get(`/Studies/${studyInstanceUid}/technician`);

export default getStudyAssignedTechnician;
